import { gql } from '@apollo/client';

export const pvWizardSection = gql`
  fragment PvWizardSection on PvWizardSection {
    __typename
    headline
    key
    text
    info
    topLine
    buttonText
    questions {
      ... on PvWizardQuestionTypeButton {
        __typename
        key
        headline
        requiresAnswers {
          key
          value
        }
        answerOptions {
          title
          subline
          value
          icon
        }
      }

      ... on PvWizardQuestionTypeDropdown {
        __typename
        key
        headline
        defaultOptionText
        requiresAnswers {
          key
          value
        }
        answerOptions {
          label
          value
        }
      }
      ... on PvWizardMultiQuestionType {
        __typename
        key
        headline
        requiresAnswers {
          key
          value
        }
        defaultAnswers {
          roofAge
          roofMaterial
        }
        questions {
          roofAge {
            key
            headline
            answerOptions {
              title
              value
            }
          }
          roofMaterial {
            key
            headline
            answerOptions {
              title
              value
            }
          }
        }
      }
    }
  }
`;
